export const UNDEFINED_AUTH_BASE_URL = new Error(
  'Please provide value for AUTH base API url in TisaCore.forRoot() method.',
);
